<header class="header">
    <div class="header-content d-flex justify-content-between align-items-center">
        <div class="header-logo d-flex align-items-center">
            <div class="logo-container">
                <img src="assets/images/psic-logo-black.svg" alt="psic-logo" />
            </div>
        </div>

        <a class="help-link d-flex flex-row psic-gap-4 align-items-center" href="tel:8003035000">
            <div class="d-flex flex-column help-text">
                <p class="Disclaimer">Need help? Call us</p>
                <p class="disclaimer-bold text-end">800 303 5000</p>
            </div>
            <mat-icon class="dg-60-color" svgIcon="phone" aria-label="phone"></mat-icon>
        </a>
    </div>
</header>
